var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26889 0 0 5.86182 0 13.0909V23.2727C0 25.6873 2.08444 27.6364 4.66667 27.6364H9.33333V16H3.11111V13.0909C3.11111 7.46182 7.98 2.90909 14 2.90909C20.02 2.90909 24.8889 7.46182 24.8889 13.0909V16H18.6667V27.6364H24.8889V29.0909H14V32H23.3333C25.9156 32 28 30.0509 28 27.6364V13.0909C28 5.86182 21.7311 0 14 0Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointmentIcon.eb20ce0bb490032ad4eaffc04bb969e3.svg";
export { ForwardRef as ReactComponent };